export default {
  title: 'Vaihda salasana',
  form: {
    email: {
      label: 'Sähköposti',
      placeholder: 'Anna sähköposti',
    },
    new_password: {
      label: 'Uusi salasana',
      placeholder: 'Anna salasana',
      requirements: 'Salasanan tulee sisältää 8 merkkiä, iso kirjain ja numero',
    },
    confirm_password: {
      label: 'Vahvista uusi salasana',
      placeholder: 'Vahvista salasana',
    },
    error_messages: {
      missing_info: 'Tiedot puuttuvat',
    },
  },
  buttons: {
    change_password: 'Vaihda salasana',
  },
};
